import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.debouncedSubmit = window.helpers.debounce(this.submit.bind(this), 200)
  }

  submit() {
    this.element.requestSubmit()
  }

  debounceSubmit() {
    this.debouncedSubmit()
  }
}
